import MyRfqs from '../../../../../../client/src/rfq/src/viewmodel/MyRfqsViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';

export default class DesMyRfqs extends DesBaseCollabAcc {

    constructor() {
        console.log('DesMyRfqs invoked');
        super(MyRfqs);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id' ];
    }
}

if (!window.customElements.get('des-my-rfqs')) {
    window.customElements.define('des-my-rfqs', DesMyRfqs);
}
